import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { Listbox } from '@headlessui/react';
import { theme } from '@xbto/design-system';
import { Col, Icon, Row, TextBody } from '../../atoms';
export default function SelectInputWeb({ value, onChange, values, label = '', placeholder = 'Please select', noValuesMessage = 'No results', getItemId, getItemValue, getSelectedItem, getSelectedItemTemplate, getItemTemplate, validate, schema, field, }) {
    const hasValues = !!(values && values.length > 0);
    const selectedItem = getSelectedItem ? getSelectedItem(value) : value;
    const validation = useMemo(() => (validate && schema ? { validate, schema, field } : {}), [validate, schema, field]);
    const handleChange = useCallback(
    // (newValue: string | undefined) => {
    (newValue) => {
        if (!onChange || newValue === undefined) {
            return;
        }
        if (validation.validate && validation.schema) {
            validation.validate(validation.field, getItemValue(newValue), validation.schema, label);
        }
        onChange(newValue);
    }, [onChange, validation, getItemValue, label]);
    const renderSelectedItemTemplate = useCallback((item, placeHolder) => {
        if (!item) {
            return _jsx(TextBody, { color: "placeholder", children: placeHolder });
        }
        return (getSelectedItemTemplate(item) || (_jsx(TextBody, { color: "placeholder", children: placeHolder })));
    }, [getSelectedItemTemplate]);
    return (_jsxs(Listbox, { value: value, onChange: handleChange, children: [_jsx(Listbox.Button, { style: {
                    // keep those styles out of Stylesheet.create, we want them to override classes
                    flexGrow: 1,
                    padding: 0,
                    paddingBlock: 0,
                    paddingInline: 0,
                    border: 'none',
                    outline: 'none',
                    appearance: 'none',
                    backgroundColor: 'transparent',
                }, children: _jsxs(Row.LR, { style: $.listboxButton, children: [renderSelectedItemTemplate(selectedItem, placeholder), _jsx(Icon, { name: "ArrowDropDown" })] }) }), _jsx(Listbox.Options, { as: "div", style: $.optionsWrapper, children: _jsx(Col, { style: $.itemsContainer, children: !hasValues ? (_jsx(Listbox.Option, { value: "null", disabled: true, style: $.itemContainer, children: _jsx(TextBody, { children: noValuesMessage }) })) : (values.map((item, idx) => (_jsx(Listbox.Option, { value: item, as: "div", style: StyleSheet.flatten([
                            $.itemContainer,
                            { borderTopWidth: idx === 0 ? 0 : 1 },
                        ]), children: ({ selected, active, }) => getItemTemplate(item, selected, active) }, getItemId(item))))) }) })] }));
}
SelectInputWeb.displayName = 'SelectInputWeb';
const $ = StyleSheet.create({
    listboxButton: {
        flexGrow: 1,
        paddingTop: Platform.select({ web: 16, default: 12 }),
        paddingBottom: Platform.select({ web: 16, default: 12 }),
        paddingLeft: Platform.select({ web: 16, default: 14 }),
        paddingRight: Platform.select({ web: 16, default: 14 }),
        paddingBlock: 0,
        paddingInline: 0,
        border: 'none',
        outline: 'none',
        appearance: 'none',
        backgroundColor: 'transparent',
    },
    optionsWrapper: { zIndex: 1 },
    itemsContainer: {
        marginTop: theme.spacing['1'],
        borderWidth: 1,
        borderColor: theme.color.border.primary,
        borderRadius: theme.radius.sm,
        backgroundColor: theme.color.background.white,
        position: 'absolute',
        top: '100%',
        left: 0,
        maxHeight: 240,
        overflowX: 'hidden',
        overflowY: 'auto',
        boxShadow: '0px 0px 10px 2px #00000012',
        width: '100%',
    },
    itemContainer: {
        padding: theme.spacing['4'],
        boxSizing: 'border-box',
        borderTopWidth: 1,
        borderTopStyle: 'solid',
        borderTopColor: theme.color.border.primary,
        cursor: 'pointer',
    },
});
